import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DualSelectComponent from './DualSelectComponent.vue';
import Icon from '@/components/icon/Icon';
import IconComponent from '@/components/icon/IconComponent.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RepeatsIncrementer',
  props: {
  modelValue: {
    type: Number,
    default: 0,
    required: false
  }
},
  setup(__props) {

const props = __props



const modified = computed(() => {
  return props.modelValue ? 'modified' : 'neutral';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DualSelectComponent, {
    onLeftSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onLeftSelect'))),
    onRightSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onRightSelect'))),
    class: _normalizeClass(["mt-2", _unref(modified)])
  }, {
    left: _withCtx(() => [
      _createVNode(IconComponent, {
        icon: _unref(Icon).MINUS
      }, null, 8, ["icon"])
    ]),
    middle: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(["flex self-center text-base font-semibold text-sage-500 opacity-80", _unref(modified)])
      }, _toDisplayString(__props.modelValue), 3)
    ]),
    right: _withCtx(() => [
      _createVNode(IconComponent, {
        icon: _unref(Icon).PLUS
      }, null, 8, ["icon"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})